import React from 'react';
import { OFFERED_LANGUAGES } from '../i18n/languageAccess';

// One-time language chooser, shown only to visitors who arrived on a ?lang=1
// link. Dismissing it counts as an answer (keeps the current language); the
// header picker stays available either way, so nobody gets stuck in the wrong language.
//
// The copy is multilingual on purpose — at this point we don't yet know which
// language the visitor reads.
export default function LanguageModal({ language, onChoose, onClose }) {
  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/50 px-4"
      role="dialog"
      aria-modal="true"
      aria-label="Izaberite jezik / Choose a language / Выберите язык"
      onClick={onClose}
    >
      <div
        className="relative w-full max-w-sm rounded-2xl bg-white p-6 text-center shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          aria-label="Zatvori"
          className="absolute right-3 top-2 text-2xl leading-none text-gray-400 hover:text-gray-700"
        >
          ×
        </button>

        <h2 className="mb-1 text-lg font-semibold text-brownSkin">Izaberite jezik</h2>
        <p className="mb-5 text-sm text-gray-500">Choose a language · Выберите язык</p>

        <div className="flex flex-col gap-2">
          {OFFERED_LANGUAGES.map((lng) => (
            <button
              key={lng.code}
              onClick={() => onChoose(lng.code)}
              className={`rounded-lg border px-4 py-3 text-base transition-colors ${
                language === lng.code
                  ? 'border-brownSkin bg-brownSkin text-white'
                  : 'border-gray-300 hover:border-brownSkin hover:bg-gray-50'
              }`}
            >
              {lng.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
